export const UPDATE_DIAGNOSTIC_SERVICE = 'UPDATE_DIAGNOSTIC_SERVICE';
// Service types
export const FIND_SERVICE_TYPES_REQUEST = 'FIND_SERVICE_TYPES_REQUEST';
export const FIND_SERVICE_TYPES_SUCCESS = 'FIND_SERVICE_TYPES_SUCCESS';
export const FIND_SERVICE_TYPES_ERROR = 'FIND_SERVICE_TYPES_ERROR';
export const SELECT_SERVICE_TYPE = 'SELECT_SERVICE_TYPE';
export const DEFAULT_SERVICE_TYPE = { name: 'Velg servicetype', value: 0 };
